function FileDownload({ src, label = '' }) {
    const filename = decodeURIComponent(src.split('/').pop());

    return (
        <a className="fileDownloadLink" href={src} download={filename} target="_blank" rel="noreferrer">
            📄 {label || filename}
        </a>
    );
}

export default FileDownload;
